import { WidgetDataService } from '@/modules/ta/legacy/widget/services/data/WidgetDataService';

export class GeoChartDataService extends WidgetDataService {}
